<!-- wallet.compon=-.html -->
<div class="wallet-container">
  <!-- Header Section -->
  <header class="wallet-header">
    <div class="header-content">
      <h1 class="header-title ks-m-0">Wallet</h1>
      <p class="header-subtitle">Manage saved payment methods</p>
    </div>
    <ng-template ngxPermissionsOnly="canAddPaymentMethod">
      <button mat-raised-button color="primary" class="add-button" (click)="openAddPaymentDialog()">
        <mat-icon style="margin-bottom: 5px">add</mat-icon>
        Add payment method
      </button>
    </ng-template>
  </header>

  <!-- Payment Methods Grid -->
  <div
    class="payment-methods-grid ks-p-5"
    style="overflow-y: scroll; max-height: 75vh"
    *ngIf="paymentMethods.length > 0"
  >
    <h4 class="header-title ks-m-0" *ngIf="creditCards.length > 0">Credit Cards</h4>
    <div class="payment-card ks-pb-4" *ngFor="let method of creditCards">
      <div class="card-header ks-p-3" [class.ks-bg-lighter-tertiary]="method.is_default">
        <div class="card-main-info">
          <div class="credit-card-custom ks-p-4">
            <div class="ks-d-flex ks-justify-content-space-between badge-icon-section">
              <div>
                <div
                  class="ks-badge-sm ks-badge-tertiary primary-method-badge"
                  *ngIf="method.is_default"
                >
                  Primary
                </div>
              </div>
              <div>
                <span
                  inlineSVG="assets/media/svg/icons/Payment/{{ method.brand.toLowerCase() }}.svg"
                ></span>
              </div>
            </div>
            <div class="ks-d-flex ks-justify-content-space-between ks-mt-6">
              <p class="card-holder-name">{{ getHolderName(method) }}</p>
            </div>
            <div class="ks-d-flex ks-justify-content-space-between">
              <div>{{ getMaskedNumber(method) }}</div>
              <div>{{ getCardExpiry(method) }}</div>
            </div>
          </div>
          <div class="card-details ks-pl-4">
            <div class="card-alias ks-font-weight-bold ks-mb-15">{{ method.alias }}</div>
            <div class="card-expiry" *ngIf="method.type === 'card'">
              Expires: {{ getCardExpiry(method) }}
            </div>
          </div>
        </div>
        <div class="card-actions">
          <button
            type="button"
            ktTooltip="Mark as primary"
            class="ks-btn-md ks-btn-icon-round ks-btn-flat-neutral ks-mr-2"
            [disabled]="method.is_default"
            (click)="setDefault(method)"
          >
            <span inlineSVG="assets/media/svg/icons/General/mark-payment-method-primary.svg"></span>
          </button>
          <button
            type="button"
            ktTooltip="Delete payment method"
            class="ks-btn-md ks-btn-icon-round ks-btn-flat-danger ks-mr-2"
            (click)="openRemoveDialog(method)"
          >
            <span inlineSVG="assets/media/svg/icons/General/delete-payment-method.svg"></span>
          </button>
        </div>
      </div>
    </div>

    <h4 class="header-title ks-m-0" *ngIf="bankAccounts.length > 0">Bank Accounts</h4>
    <div class="payment-card ks-pb-4" *ngFor="let method of bankAccounts">
      <div class="card-header ks-p-3" [class.ks-bg-lighter-tertiary]="method.is_default">
        <div class="card-main-info">
          <div class="ks-p-4">
            <div class="ks-d-flex ks-justify-content-space-between badge-icon-section">
              <div>
                <div
                  class="ks-badge-sm ks-badge-tertiary primary-account-badge"
                  *ngIf="method.is_default"
                >
                  Primary
                </div>
                <div class="ks-text-center">
                  <span inlineSVG="assets/media/svg/icons/Payment/bank-account.svg"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="card-details ks-pl-4">
            <div class="card-alias ks-font-weight-bold ks-mb-0">{{ getAccountName(method) }}</div>
            <div class="bank-details">{{ getBankName(method) }}</div>
            <div class="bank-details ks-mb-4">{{ getMaskedNumber(method) }}</div>
            <div class="bank-details">Added on: {{ method.created_at | date : 'dd/MM/yyyy' }}</div>
          </div>
        </div>
        <div class="card-actions">
          <button
            type="button"
            ktTooltip="Mark as primary"
            class="ks-btn-md ks-btn-icon-round ks-btn-flat-neutral ks-mr-2"
            [disabled]="method.is_default"
            (click)="setDefault(method)"
          >
            <span inlineSVG="assets/media/svg/icons/General/mark-payment-method-primary.svg"></span>
          </button>
          <button
            type="button"
            ktTooltip="Delete payment method"
            class="ks-btn-md ks-btn-icon-round ks-btn-flat-danger ks-mr-2"
            (click)="openRemoveDialog(method)"
          >
            <span inlineSVG="assets/media/svg/icons/General/delete-payment-method.svg"></span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="paymentMethods.length === 0">
    <span inlineSVG="assets/icons/two-credit-card.svg" class="svg-icon svg-icon-7x"></span>
    <h3 class="empty-title">No saved payment methods</h3>
    <p class="header-subtitle ks-m-0">Start by adding a credit card or bank account to manage</p>
    <p class="header-subtitle">customer payments efficiently.</p>
    <ng-template ngxPermissionsOnly="canAddPaymentMethod">
      <button mat-raised-button color="primary" class="add-button" (click)="openAddPaymentDialog()">
        Add your first payment method
      </button>
    </ng-template>
  </div>
</div>
